import RenderWhenVisible from 'Component/RenderWhenVisible';
import {
    WidgetFactory as SourceWidgetFactory
} from 'SourceComponent/WidgetFactory/WidgetFactory.component';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

import {
    CATALOG_PRODUCT_LIST,
    NEW_PRODUCTS,
    SLIDER
} from './WidgetFactory.config';

export const ProductListWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-product-list" */
    'Component/ProductListWidget'
), 2);
export const NewProducts = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-new-product" */
    'Component/NewProducts'
), 2);
export const HomeSlider = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-slider" */
    'Component/SliderWidget'
), 2);

export const SubCategoriesSliderWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-recently-viewed" */
    'Component/SubCategoriesSliderWidget'
), 2);

export const ShippingMethodSimulatorWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-shipping-method-simulatro" */
    'Component/ShippingMethodSimulatorWidget'
), 2);

export const SaleCountdownWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-sale-countdown" */
    'Component/SaleCountdownWidget'
), 2);

/** @namespace Bodypwa/Component/WidgetFactory/Component */
export class WidgetFactoryComponent extends SourceWidgetFactory {
    renderMap = {
        [SLIDER]: {
            component: HomeSlider,
            fallback: this.renderSliderFallback
        },
        [NEW_PRODUCTS]: {
            component: NewProducts
        },
        [CATALOG_PRODUCT_LIST]: {
            component: ProductListWidget
        },
        saleCountDown: {
            component: SaleCountdownWidget
        },
        subCategoriesSlider: {
            component: SubCategoriesSliderWidget
        },
        simulateShippingRate: {
            component: ShippingMethodSimulatorWidget
        }
    };

    renderWidget() {
        const {
            type,
            sliderId = null,
            displayType,
            productsCount,
            showPager,
            storeId,
            title,
            conditionsEncoded,
            'data-category': categoryId
        } = this.props;
        const {
            component: Widget
        } = this.renderMap[type] || {};

        return (
                <Widget
                  sliderId={ sliderId }
                  displayType={ displayType }
                  productsCount={ productsCount }
                  showPager={ showPager }
                  storeId={ storeId }
                  title={ title }
                  categoryId={ categoryId }
                  conditionsEncoded={ conditionsEncoded }
                  widgetProps={ this.props }
                />
        );
    }

    renderContent() {
        const {
            type
        } = this.props;

        const {
            component: Widget,
            fallback
        } = this.renderMap[type] || {};

        if (type === 'saleCountDown') {
            return this.renderWidget();
        }

        if (Widget !== undefined) {
            return (
                <RenderWhenVisible fallback={ fallback } elem={ type }>
                    { this.renderWidget() }
                </RenderWhenVisible>
            );
        }

        return null;
    }
}

export default WidgetFactoryComponent;
